module.exports = __webpack_public_path__ + "img/sel_Shanghai.9d667a2b.jpg";